import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

export async function hapticTap() {
  if (Capacitor.getPlatform() === 'web') return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {} // falla silenciosamente si el device no soporta
}